/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-cycle */
import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { ProfileInterface } from './profileTypes';
import style from './profile.module.scss';
import '../../constants/_global.scss';
import AvatarLarge from '../../UI/avatar/avatarLarge';
import Input from '../../UI/input/inputComponent';
import { INPUT_TYPE } from '../../UI/input/inputTypes';
import Button from '../../UI/button/buttonComponent';
import { BUTTON_TYPE, BUTTON_VER } from '../../UI/button/buttonTypes';
import { LOCAL_STORAGE, UserInterface } from '../../constants/constants';
import { useDispatch, useSelector } from '../../index';
import { updateProfile } from '../../service/UserData';

const Profile: React.FC<ProfileInterface> = ({ onEdit }) => {
  const data = useSelector((state) => state.userData.user);
  const dispatch = useDispatch();
  const newData = {
    ...data,
    password: localStorage.getItem(LOCAL_STORAGE.PASSWORD) || '',
  };

  const [formData, setFormData] = useState<UserInterface>(
    newData || {
      id: 0,
      name: '',
      email: '',
      password: '',
      avatar: '',
    }
  );

  const resolution = {
    DesktopOrLaptop: useMediaQuery({ minWidth: 800 }),
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setFormData((prevState) => ({
        ...prevState,
        avatar: file,
      }));
    }
  };

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onEdit(formData);
    const data = new FormData();
    if (formData.name) {
      data.append('name', formData.name);
    }

    if (formData.email) {
      data.append('email', formData.email);
    }

    if (formData.password) {
      data.append('password', formData.password);
    }

    if (formData.avatar) {
      data.append('avatar', formData.avatar);
    }
    console.log(formData);
    dispatch(updateProfile(data));
  };

  return (
    <form
      className={
        resolution.DesktopOrLaptop ? style.shellDesktop : style.shellMobile
      }
      encType="multipart/form-data"
    >
      <div
        className={
          resolution.DesktopOrLaptop ? style.profile : style.profileMobile
        }
      >
        <h1 className="h1 zeroMargin">Мой профиль</h1>
        {!resolution.DesktopOrLaptop ? (
          <AvatarLarge
            onEdit={handleFileChange}
            avatar={
              typeof formData.avatar === 'string' ? formData.avatar : undefined
            }
          />
        ) : null}
        <Input
          name="name"
          ver={INPUT_TYPE.REGULAR}
          errStatus={false}
          placeholder="Имя"
          inputValue={formData.name}
          customWidth={!resolution.DesktopOrLaptop ? 800 : 472}
          customMargin={0}
          onChange={handleChange}
        />
        <Input
          name="email"
          ver={INPUT_TYPE.REGULAR}
          errStatus={false}
          placeholder="Email"
          inputValue={formData.email}
          customWidth={!resolution.DesktopOrLaptop ? 800 : 472}
          customMargin={0}
        />
        <Input
          name="password"
          ver={INPUT_TYPE.PASSWORD}
          errStatus={false}
          placeholder="Пароль"
          inputValue={formData.password}
          customWidth={!resolution.DesktopOrLaptop ? 800 : 312}
          customMargin={0}
          onChange={handleChange}
        />
        <Button
          type={BUTTON_TYPE.Submit}
          ver={BUTTON_VER.primary}
          text="Сохранить изменения"
          customWidth={!resolution.DesktopOrLaptop ? 800 : 235}
          onClick={(e) => onSubmit(e)}
        />
      </div>
      {resolution.DesktopOrLaptop ? (
        <AvatarLarge
          onEdit={handleFileChange}
          avatar={
            typeof formData.avatar === 'string' ? formData.avatar : undefined
          }
        />
      ) : null}
    </form>
  );
};

export default Profile;
